import { render, staticRenderFns } from "./ArticleListIndex copy.vue?vue&type=template&id=0a0585d1&scoped=true"
import script from "./ArticleListIndex copy.vue?vue&type=script&lang=js"
export * from "./ArticleListIndex copy.vue?vue&type=script&lang=js"
import style0 from "./ArticleListIndex copy.vue?vue&type=style&index=0&id=0a0585d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0585d1",
  null
  
)

export default component.exports